module.exports = __webpack_public_path__ + "img/127.7a8b5b94.jpg";